import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApiToken } from './useApiToken'
import { onboardingApi } from '../lib/api/onboarding'
import type { ChatMessage } from '../lib/api/types'

const statusKey = (customerId: string) => ['onboarding', 'status', customerId] as const

export function useOnboardingStatus(customerId: string | null) {
  const getToken = useApiToken()
  return useQuery({
    queryKey: statusKey(customerId ?? ''),
    queryFn: async () => {
      const token = await getToken()
      return onboardingApi.getStatus(token, customerId!)
    },
    enabled: !!customerId,
  })
}

export function useStoreCredentials() {
  const getToken = useApiToken()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (data: { customer_id: string; tenant_id: string; client_id: string; client_secret: string }) => {
      const token = await getToken()
      return onboardingApi.storeCredentials(token, data)
    },
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: statusKey(vars.customer_id) })
    },
  })
}

export function useSendChat(customerId: string) {
  const getToken = useApiToken()
  return useMutation({
    mutationFn: async (messages: ChatMessage[]) => {
      const token = await getToken()
      return onboardingApi.chat(token, customerId, messages)
    },
  })
}
